export var Type = {
  Default: 'default',
  Success: 'success',
  Error: 'error',
  Warning: 'warning'
};